import { render, staticRenderFns } from "./InputTextMailFromWhiteListVinculadosDialog.vue?vue&type=template&id=40e385f0&"
import script from "./InputTextMailFromWhiteListVinculadosDialog.vue?vue&type=script&lang=js&"
export * from "./InputTextMailFromWhiteListVinculadosDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports